export default {
      id: "icon-visuels-usage",
      viewBox: "0 0 16 17",
      url: __webpack_public_path__ + "icons.svg#icon-visuels",
      toString: function () {
        return this.url;
      }
    }